import request from 'untils/request';

// 获取在售会员卡列表
export function getSaleMembershipCard(type) {
  return request({
    method: 'get',
    url: `/member/program?cardCateGory=${type}`,
  });
}

// 获取用户会员卡列表
export function getUserMembershipCard() {
  return request({
    method: 'get',
    url: `/member/user`,
  });
}

// 获取会员卡详情
export function getMemberDetails(id) {
  return request({
    method: 'get',
    url: `/member/details?card_id=${id}`,
  });
}

// 会员卡取消订阅
export function cancelMemberCard(params = {}) {
  return request({
    method: 'POST',
    url: `/member/unsubscribe`,
    params
  });
}

// 会员卡信息提交，订阅
export function submitMemberInfo(params = {}) {
  return request({
    method: 'POST',
    url: `/member/subscription`,
    params
  });
}

// 会员卡订阅成功回调
export function submitMemberCallback(params = {}) {
  return request({
    method: 'POST',
    url: `/member/subscription/callback`,
    params
  });
}

// 用户确认退订（邮件）
export function confirmCancelEmail(params = {}) {
  return request({
    method: 'POST',
    url: `/member/unsubscribe/confirm`,
    params
  });
}

// 领取优惠券，挽回退订用户（邮件）
export function getCouponsEmail(params = {}) {
  return request({
    method: 'POST',
    url: `/member/unsubscribe/get_coupons`,
    params
  });
}

// 退订成功赠送优惠券（邮件）
export function sendCouponsEmail(params = {}) {
  return request({
    method: 'POST',
    url: `/member/unsubscribe/complete`,
    params
  });
}

// 获取国家列表
export function getCountryList(params = {}){
  return request({
    method:'get',
    url:`/linkage/country`,
    params,
  })
}

// 获取国家下州/省
export function getStateList(params={}){
  return request({
    method:'get',
    url:`/linkage/state`,
    params,
  })
}

// 游客身份开通会员渠道统计
export function sendMembershipSource(id, source) {
  return request({
    method: 'POST',
    url: `/module/schedule_membership_source?cardId=${id}&source=${source}`,
  });
}